export default "__VITE_ASSET__3tbCSErY__"